import { DeviceCalibration } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

/** Every device on a facility's pitches with its calibration. SystemAdmin only. */
export const getDeviceCalibrations = async (
  facilityId: number
): Promise<DeviceCalibration[]> => {
  const { data } = await queryBuilder('GET', 'devices', { facilityId });
  return data;
};
